import { type AppConfigStoreState } from '../../types';
import { useSetEmbedConfig } from '../use-set-embed-config';
import { useSetClientConfig } from '../use-set-teams-client-config';
import { useSetTeamsNavigationConfig } from '../use-set-teams-navigation-config';
import { useSetTeamsPreviewPanelConfig } from '../use-set-teams-preview-panel-config';
import { useSetTeamsProductConfig } from '../use-set-teams-product-config';

export const useSetAppConfig = (
	appConfig: AppConfigStoreState,
): {
	isClientReady: boolean;
} => {
	const { isClientReady } = useSetClientConfig({
		cloudId: appConfig.cloudId,
		stargateRoot: appConfig.stargateRoot,
		env: appConfig.env,
		orgId: appConfig.orgId,
		principalUserId: appConfig.principalUserId,
	});

	useSetTeamsProductConfig({
		appName: appConfig.appName,
		productName: appConfig.productName,
		isJiraAvailable: appConfig.isJiraAvailable,
		subProduct: appConfig.subProduct,
		locale: appConfig.locale,
		productFeatureFlags: appConfig.productFeatureFlags,
		openLinksInNewTab: appConfig.openLinksInNewTab,
	});

	useSetTeamsNavigationConfig({
		contextSpaPaths: appConfig.contextSpaPaths,
		contextEntryPoint: appConfig.contextEntryPoint,
	});

	useSetTeamsPreviewPanelConfig({
		openPreviewPanel: appConfig.openPreviewPanel,
	});

	useSetEmbedConfig({
		openGiveKudosInNewTab: appConfig.openGiveKudosInNewTab,
	});

	return { isClientReady };
};
